import BaseChart from './BaseChart';

/**
 * Word Cloud chart implementation using VChart
 */
class WordCloudChart extends BaseChart {
  /**
   * Get chart specification for word cloud chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Word Cloud specific fields — auto-detect from data when defaults don't match
    const wordField = this._resolveField('wordField', 'word', ['text', 'term', 'label', 'name', 'keyword'])
      || this._resolveNameField();
    const weightField = this._resolveField('weightField', 'weight', ['value', 'count', 'frequency', 'size', 'score'])
      || this._resolveValueField();
    const colorField = this.options.colorField;
    
    return {
      type: 'wordCloud',
      data,
      wordField,
      weightField,
      colorField,
      
      // Padding between words
      padding: this.options.padding || 1,
      
      // Font settings
      fontFamily: this.options.fontFamily || 'sans-serif',
      fontWeight: this.options.fontWeight || 'normal',
      
      // Size range for words
      sizeRange: this.options.sizeRange || [12, 60],
      
      // Color configuration
      color: colorField ? {
        type: 'ordinal',
        ...this.options.colorScale
      } : undefined,
      
      // Word Cloud specific styling
      wordCloud: {
        style: {
          fontOpacity: 1,
          ...this.options.wordCloudStyle
        },
        state: {
          hover: {
            fontOpacity: 0.8,
            fontSize: (datum, element) => {
              const currentSize = element.attribute?.fontSize;
              return currentSize ? currentSize * 1.1 : currentSize;
            }
          },
          ...this.options.wordCloudState
        }
      },
      
      // Shape of the word cloud
      shape: this.options.shape || 'circle',
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
}

export default WordCloudChart; 